import { useState } from "react";
import React from "react";
import Turnstile from "react-turnstile"; // Daha kararlı paket
import axios from "axios"; // İstek atmak için

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => {
    setState({ ...initialState });
    setTurnstileToken(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Captcha Kontrolü
    if (!turnstileToken) {
      alert("Lütfen robot olmadığınızı doğrulayın!");
      return;
    }

    setLoading(true);

    // 2. Kendi Backend'imize İstek (EmailJS YOK)
    try {
      // Backend URL'niz (Canlıda https://omemtech.com/api/send-email olacak)
      const response = await axios.post("https://www.omemtech.com/api/send-email", {
        name,
        email,
        message,
        token: turnstileToken,
      });

      if (response.status === 200) {
        alert("Mesajınız başarıyla gönderildi!");
        clearState();
      }
    } catch (error) {
      console.error("Mail hatası:", error);
      alert("Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>İletişim</h2>
                <p>
                  Lütfen bize ulaşmak için formu doldurunuz. Size en yakın zamanda geri dönüş yapacağız
                </p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="İsim"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4" // rows string değil sayı olabilir, ama HTML için string de ok
                    placeholder="Mesajınız"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>

                {/* Cloudflare Turnstile (Yeni Paket) */}
                <div className="form-group" style={{ marginBottom: "20px", minHeight: "65px" }}>
                  <Turnstile
                    sitekey="0x4AAAAAACOI5R0BjuJMjBJt" // Kendi Site Key'inizi buraya yapıştırın
                    onVerify={(token) => setTurnstileToken(token)}
                  />
                </div>

                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg" disabled={loading}>
                  {loading ? "Gönderiliyor..." : "Gönder"}
                </button>
              </form>
            </div>
          </div>
          
          {/* İletişim Bilgileri - Hata Önleyici Kontroller Eklendi (? işareti) */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Bize Ulaşın</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Adres
                </span>
                {props.data?.address ? props.data.address : "Yükleniyor..."}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Telefon
                </span>{" "}
                {props.data?.phone ? props.data.phone : "Yükleniyor..."}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data?.email ? props.data.email : "Yükleniyor..."}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data?.instagram ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data?.linkedin ? props.data.linkedin : "/"}>
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            <a>2026 OMEMTECH</a>
          </p>
        </div>
      </div>
    </div>
  );
};